module.exports = __webpack_public_path__ + "img/files.3688f25a.png";